/**
 * Auth state + actions (webportal atom-class convention, trimmed to
 * template size). Read state with useAtomValue, trigger actions with
 * useSetAtom — action atoms are write-only verbs.
 */

import type { User } from "firebase/auth";
import { OAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { atom } from "jotai";
import { auth } from "@/firebase";

const firebaseUserAtom = atom<User | null>(auth.currentUser);
firebaseUserAtom.onMount = (set) => auth.onAuthStateChanged(set);

export const currentUserAtom = atom((get) => get(firebaseUserAtom));

export const signInAtom = atom(null, async () => {
  const provider = new OAuthProvider("microsoft.com");
  // Guardrail #6: pin the customer's Entra tenant so only their directory
  // can initiate sign-in. openid/profile/email scopes make Microsoft
  // return the email claim reliably (PLUS learned this the hard way).
  provider.setCustomParameters({
    tenant: import.meta.env.VITE_ENTRA_TENANT_ID,
    prompt: "select_account",
  });
  provider.addScope("openid");
  provider.addScope("profile");
  provider.addScope("email");
  await signInWithPopup(auth, provider);
});

export const signOutAtom = atom(null, async () => {
  await signOut(auth);
});
